// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.invl {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .invl {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .invl {
    padding: 16px 16px 28px;
  }
}

.invl-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
}
@media (max-width: 640px) {
  .invl-header {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }
}
.invl-header__left {
  flex: 1;
}
.invl-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.invl-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
}
@media (max-width: 640px) {
  .invl-header__title {
    font-size: 22px;
  }
}

.invl-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
}
.invl-breadcrumb li {
  display: flex;
  align-items: center;
}
.invl-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.invl-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.invl-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.invl-breadcrumb li.invl-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.invl-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .invl-toolbar {
    gap: 10px;
    padding: 12px 16px;
  }
}
@media (max-width: 640px) {
  .invl-toolbar .invl-searchbar {
    flex-basis: 100%;
    max-width: none;
  }
  .invl-toolbar .invl-archived {
    margin-left: 0;
  }
}

.invl-searchbar {
  display: flex;
  align-items: center;
  flex: 1 1 420px;
  max-width: 620px;
  min-width: 0;
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.invl-searchbar:focus-within {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}
.invl-searchbar__icon {
  padding: 0 8px 0 14px;
  color: #ccc;
  font-size: 13px;
}
.invl-searchbar__input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  padding: 10px 8px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
}
.invl-searchbar__input::placeholder {
  color: #ccc;
}
.invl-searchbar__clear {
  flex: 0 0 auto;
  background: #ccc;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  padding: 0;
  margin-right: 6px;
  transition: background 0.15s ease;
}
.invl-searchbar__clear:hover {
  background: #676a6c;
}
.invl-searchbar__divider {
  width: 1px;
  align-self: stretch;
  background: #e7eaec;
  margin: 7px 0;
}
.invl-searchbar__select {
  position: relative;
  display: flex;
  align-items: center;
  transition: background 0.15s ease;
}
.invl-searchbar__select:hover {
  background: #f1f1f2;
}
.invl-searchbar__field {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;
  padding: 10px 34px 10px 14px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
}
.invl-searchbar__caret {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  font-size: 14px;
  pointer-events: none;
}

.invl-archived {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 0 auto;
  font-size: 13px;
  font-weight: 500;
  color: #ccc;
  cursor: pointer;
  white-space: nowrap;
}
.invl-archived input {
  cursor: pointer;
  margin: 0;
}

.invl-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
  line-height: 1.4;
}
.invl-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.invl-btn--primary:hover {
  background: #4cae4c;
  border-color: #4cae4c;
}

.invl-content {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7eaec;
  overflow: hidden;
  min-height: 200px;
}
.invl-content .table-responsive {
  overflow-x: auto;
}
.invl-content table {
  width: 100%;
  margin-bottom: 0;
  border-collapse: collapse;
}
.invl-content table thead tr {
  background: #f1f1f2;
}
.invl-content table thead tr th {
  padding: 9px 10px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  border-top: none;
  white-space: nowrap;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: default;
}
.invl-content table thead tr th.cursor-pointer {
  cursor: pointer;
}
.invl-content table thead tr th.cursor-pointer:hover {
  color: rgb(0, 173, 208);
}
.invl-content table thead tr th.cursor-pointer i {
  margin-left: 4px;
  font-size: 12px;
}
.invl-content table tbody tr {
  transition: background-color 0.12s ease;
  border-bottom: 1px solid #e7eaec;
  cursor: pointer;
}
.invl-content table tbody tr:hover {
  background-color: rgba(0, 173, 208, 0.03);
}
.invl-content table tbody tr:nth-of-type(even) {
  background-color: rgba(241, 241, 242, 0.5);
}
.invl-content table tbody tr:nth-of-type(even):hover {
  background-color: rgba(0, 173, 208, 0.03);
}
.invl-content table tbody tr td {
  padding: 8px 10px;
  font-size: 12px;
  color: #676a6c;
  vertical-align: middle;
  border-top: none;
}
.invl-content table tbody tr td a:not(.invl-actions__opr) {
  color: #676a6c;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease;
}
.invl-content table tbody tr td a:not(.invl-actions__opr):hover {
  color: rgb(0, 173, 208);
}
.invl-content table tbody tr td a.invl-namelink {
  font-weight: 700;
}

.invl-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.invl-actions__opr {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1;
  border: 1px solid transparent;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  background: transparent;
  color: #9aa0a6;
  border-color: #e7eaec;
}
.invl-actions__opr--edit:hover {
  background: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
  transform: scale(1.08);
}
.invl-actions__opr--copy:hover {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
  transform: scale(1.08);
}
.invl-actions__opr--delete:hover, .invl-actions__opr--archive:hover {
  background: rgb(245, 67, 89);
  color: #fff;
  border-color: rgb(245, 67, 89);
  transform: scale(1.08);
  box-shadow: 0 2px 8px rgba(245, 67, 89, 0.3);
}
.invl-actions__opr--restore:hover {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
  transform: scale(1.08);
}

.invl-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.invl-state > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.invl-state p {
  font-size: 15px;
  color: #ccc;
  margin: 0;
}

.inv-pill {
  display: inline-block;
  border-radius: 10px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
}

.inv-pill--open {
  background: rgba(105, 190, 40, 0.12);
  color: #4d8b1d;
}

.inv-pill--closed {
  background: #f1f1f2;
  color: #8a9099;
}

.inv-prog {
  height: 6px;
  background: #eef0f1;
  border-radius: 3px;
  margin-top: 3px;
  width: 72px;
  max-width: 100%;
  overflow: hidden;
}

.inv-prog__bar {
  height: 6px;
  background: #4d8b1d;
  border-radius: 3px;
}

.inv-prog__label {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  margin-bottom: 2px;
}
.inv-prog__label b {
  font-size: 17px;
  font-weight: 700;
  color: #4d8b1d;
  line-height: 1;
}
.inv-prog__label i {
  font-style: normal;
  font-size: 11px;
  font-weight: 600;
  color: #9aa0a6;
}

.invl-results {
  display: inline-flex;
  flex-direction: column;
  text-decoration: none;
}
.invl-results .inv-prog, .invl-results .inv-prog__bar {
  display: block;
}
.invl-results:hover .inv-prog__label b {
  color: rgb(0, 173, 208);
}

.invl-orglink,
.invl-namelink {
  color: #676a6c !important;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.15s ease;
}
.invl-orglink:hover,
.invl-namelink:hover {
  color: rgb(0, 173, 208) !important;
}

.invl-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #e7eaec;
  flex-wrap: wrap;
}
.invl-pager__info {
  font-size: 12px;
  color: #ccc;
}
.invl-pager__ctrls {
  display: flex;
  gap: 4px;
}
.invl-pager__btn {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invl-pager__btn:hover:not(:disabled):not(.is-active) {
  background: #f1f1f2;
  border-color: #ccc;
}
.invl-pager__btn.is-active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
.invl-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.invl-pager__left {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.invl-perpage {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  color: #ccc;
}
.invl-perpage select {
  padding: 4px 8px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 12px;
  color: #676a6c;
  cursor: pointer;
  outline: none;
}

.invl-fu {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 10px;
}
.invl-fu--open {
  background: rgba(105, 190, 40, 0.12);
  color: #4d8b1d;
}
.invl-fu--muted {
  background: #f1f1f2;
  color: #8a9099;
}
.invl-fu__date {
  white-space: nowrap;
}

.invl-dates {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
}
.invl-dates__lbl {
  color: #9aa0a6;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-right: 5px;
}

.inv-avatar {
  display: inline-flex;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #00add0;
  color: #fff;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  margin-right: 2px;
}

.inv-avatar.inv-avatar--grey {
  background: #e7eaec;
  color: #6d6e71;
}

.inv-avatar.inv-avatar--grey-lighter {
  background: #f1f1f2;
  color: #6d6e71;
}

.inv-avatar__more {
  color: #9aa0a6;
  font-size: 11px;
}

.invm {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .invm {
    padding-left: 240px;
  }
}
.invm__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}
.invm__card {
  position: relative;
  z-index: 1;
  width: min(780px, 100%);
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.invm__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
  flex-shrink: 0;
}
.invm__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.invm__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}
.invm__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}
.invm__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.invm__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}
.invm__body {
  padding: 20px 24px 24px;
  overflow-y: auto;
}
.invm .inv-wizard {
  max-width: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/invitations/list/invitations-list.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AArYA;EACE,uBAAA;EACA,iBAAA;AAwYF;AAtYE;EAJF;IAI8B,uBAAA;EA0Y5B;AACF;AA1YE;EALF;IAK8B,uBAAA;EA8Y5B;AACF;;AA3YA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA8YF;AA5YE;EAPF;IAO8B,sBAAA;IAAwB,uBAAA;IAAyB,mBAAA;EAkZ7E;AACF;AAjZE;EAAU,OAAA;AAoZZ;AAnZE;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAwZrD;AAtZE;EACE,eAAA;EACA,gBAAA;EACA,cDOiB;ECNjB,SAAA;EACA,uBAAA;EACA,wEDpCS;ECqCT,gBAAA;AAwZJ;AAtZI;EATF;IAS8B,eAAA;EA0Z9B;AACF;;AArZA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,WDVkB;ACkapB;AAtZE;EACE,aAAA;EACA,mBAAA;AAwZJ;AAtZI;EAA4B,YAAA;EAAc,aAAA;EAAe,WDhBzC;ECgBoE,eAAA;AA4ZxF;AA1ZI;EACE,cD1Be;EC2Bf,qBAAA;EACA,4BAAA;AA4ZN;AA3ZM;EAAU,uBD3CA;ACychB;AA3ZI;EAA6B,cD3BZ;EC2BwC,gBAAA;AA+Z7D;;AA1ZA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBDpCoB;ECqCpB,kBAAA;EACA,yBAAA;AA6ZF;AA3ZE;EAXF;IAW8B,SAAA;IAAW,kBAAA;EAgavC;AACF;AAhaE;EACE;IAAkB,gBAAA;IAAkB,eAAA;EAoatC;EAnaE;IAAiB,cAAA;EAsanB;AACF;;AAlaA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AAqaF;AAnaE;EAAiB,8BDlFH;ECkFiC,4CAAA;AAuajD;AAraE;EAAU,qBAAA;EAAuB,WD/Df;EC+D0C,eAAA;AA0a9D;AAxaE;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,wEDnHS;ECoHT,cDjFiB;AC2frB;AAxaI;EAAiB,WD5ED;ACufpB;AAxaE;EACE,cAAA;EACA,gBDjFgB;ECkFhB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,iCAAA;AA0aJ;AAzaI;EAAU,mBDtGO;ACkhBrB;AAzaE;EAAa,UAAA;EAAY,mBAAA;EAAqB,mBD3FjC;EC2F4D,aAAA;AA+a3E;AA7aE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iCAAA;AA+aJ;AA9aI;EAAU,mBDxGQ;ACyhBtB;AA9aE;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDjKS;ECkKT,cD/HiB;AC+iBrB;AA7aE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WDhIgB;ECiIhB,eAAA;EACA,oBAAA;AA+aJ;;AA3aA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WD7IkB;EC8IlB,eAAA;EACA,mBAAA;AA8aF;AA5aE;EAAQ,eAAA;EAAiB,SAAA;AAgb3B;;AA5aA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,wEDxMW;ECyMX,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AA+aF;AA7aE;EACE,6BDzLY;EC0LZ,WAAA;EACA,+BD3LY;AC0mBhB;AA9aI;EAAU,mBDtKK;ECsK0B,qBDtK1B;ACwlBnB;;AA7aA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AAgbF;AA9aE;EAAoB,gBAAA;AAibtB;AA/aE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AAibJ;AA/aI;EACE,mBD5LgB;AC6mBtB;AA/aM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDvMa;ECwMb,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,wEDnPK;ECoPL,eAAA;AAibR;AA/aQ;EACE,eAAA;AAibV;AAhbU;EAAU,uBDnOJ;ACspBhB;AAlbU;EAAI,gBAAA;EAAkB,eAAA;AAsbhC;AAjbI;EACE,uCAAA;EACA,gCAAA;EACA,eAAA;AAmbN;AAjbM;EAAU,yCAAA;AAobhB;AAnbM;EACE,0CAAA;AAqbR;AApbQ;EAAU,yCAAA;AAublB;AApbM;EACE,iBAAA;EACA,eAAA;EACA,cDzOa;EC0Ob,sBAAA;EACA,gBAAA;AAsbR;AAlbQ;EACE,cDhPW;ECiPX,qBAAA;EACA,gBAAA;EACA,4BAAA;AAobV;AAnbU;EAAU,uBDlQJ;ACwrBhB;AApbQ;EAAkB,gBAAA;AAub1B;;AAhbA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAmbF;AAjbE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EAGA,uBAAA;EACA,cAAA;EACA,qBDvQW;ACwrBf;AA/aI;EAAgB,4BDrSJ;ECqSgC,WAAA;EAAa,8BDrS7C;ECqS2E,sBAAA;AAqb3F;AApbI;EAAgB,6BDpSJ;ECoSgC,WAAA;EAAa,+BDpS7C;ECoS2E,sBAAA;AA0b3F;AAzbI;EACmB,4BDrSL;ECqSmC,WAAA;EAAa,8BDrShD;ECqSgF,sBAAA;EAAwB,4CAAA;AA+b1H;AA9bI;EAAmB,6BDvSP;ECuSmC,WAAA;EAAa,+BDvShD;ECuS8E,sBAAA;AAoc9F;;AA/bA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAkcF;AAhcE;EAAQ,eAAA;EAAiB,mBAAA;EAAqB,WDjS5B;ACsuBpB;AApcE;EAAI,eAAA;EAAiB,WDlSH;ECkS8B,SAAA;AAyclD;;AAncA;EAAY,qBAAA;EAAuB,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;AA2c5F;;AA1cA;EAAkB,oCAAA;EAAwC,cA5UzC;AA2xBjB;;AA9cA;EAAoB,mBAAA;EAAqB,cAAA;AAmdzC;;AAhdA;EAAY,WAAA;EAAa,mBAAA;EAAqB,kBAAA;EAAoB,eAAA;EAAiB,WAAA;EAAa,eAAA;EAAiB,gBAAA;AA0djH;;AAzdA;EAAiB,WAAA;EAAa,mBAjVb;EAiV0C,kBAAA;AA+d3D;;AA5dA;EACE,oBAAA;EAAsB,qBAAA;EAAuB,QAAA;EAAU,kBAAA;AAkezD;AAjeE;EAAI,eAAA;EAAiB,gBAAA;EAAkB,cAtVxB;EAsVgD,cAAA;AAuejE;AAteE;EAAI,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AA4e7D;;AAzeA;EACE,oBAAA;EACA,sBAAA;EACA,qBAAA;AA4eF;AA3eE;EAA4B,cAAA;AA8e9B;AA7eE;EAA6B,uBDjVf;ACi0BhB;;AA3eA;;EAEE,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;AA8eF;AA7eE;;EAAU,kCAAA;AAifZ;;AA7eA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAgfF;AA9eE;EAAU,eAAA;EAAiB,WDpVT;ACs0BpB;AAjfE;EAAW,aAAA;EAAe,QAAA;AAqf5B;AApfE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cDpWiB;ECqWjB,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAsfJ;AApfI;EAAyC,mBDlWvB;ECkWyD,kBDnW3D;AC21BpB;AAvfI;EAAc,mBDtWG;ECsW8B,WAAA;EAAa,qBDtW3C;ACk2BrB;AA3fI;EAAa,YAAA;EAAc,mBAAA;AA+f/B;;AA5fA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;AAmgBnE;;AAlgBA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,SAAA;EAAW,eAAA;EAAiB,WD1W/D;ACo3BpB;AAzgBE;EAAS,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,cDlX9E;ECkX0G,eAAA;EAAiB,aAAA;AAkhBhJ;;AA9gBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EAEA,gBAAA;EACA,mBAAA;AAghBF;AA7gBE;EAAU,oCAAA;EAAwC,cA7ZnC;AA86BjB;AAhhBE;EAAW,mBAAA;EAAqB,cAAA;AAohBlC;AAnhBE;EAAU,mBAAA;AAshBZ;;AAlhBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAqhBF;AAphBE;EAAS,cAAA;EAAgB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;EAAwB,iBAAA;AA2hB9F;;AAzhBA;EAAc,oBAAA;EAAsB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,mBAAA;EAAqB,WAAA;EAAa,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;EAAgB,iBAAA;AAsiBnL;;AAniBA;EAA+B,mBDrYhB;ECqY2C,cD9YrC;ACs7BrB;;AAviBA;EAAuC,mBD5YjB;EC4YmD,cD/YpD;AC27BrB;;AA3iBA;EAAoB,cAAA;EAAgB,eAAA;AAgjBpC;;AA3iBA;EACE,eAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AA8iBF;AA5iBE;EATF;IASyB,mBAAA;EAgjBvB;AACF;AA/iBE;EAAa,eAAA;EAAiB,QAAA;EAAU,+BAAA;EAAiC,UAAA;AAqjB3E;AAnjBE;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0EAAA;EACA,gBAAA;AAqjBJ;AAljBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qDAAA;EACA,gCAAA;EACA,cAAA;AAojBJ;AAjjBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BD9cY;EC+cZ,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAmjBJ;AAhjBE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDtc3B;ECscuD,wED9e/D;EC8eyF,SAAA;EAAW,gBAAA;AAwjBjH;AAvjBE;EAAc,eAAA;EAAiB,cD5cZ;EC4cwC,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AA8jBhG;AA5jBE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WDndgB;ECodhB,0BAAA;EACA,cAAA;AA8jBJ;AA7jBI;EAAU,mCAAA;EAA0C,uBDxetC;ECwe+D,oCAAA;AAkkBjF;AA/jBE;EAAU,uBAAA;EAAyB,gBAAA;AAmkBrC;AAhkBE;EAAc,eAAA;AAmkBhB","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n\n// ─────────────────────────────────────────────\n// Invitations listing — mirrors the Rosters (orgs) listing chrome\n// ─────────────────────────────────────────────\n\n// The single green used across the table (Status pill, Presentation chip, scored count,\n// progress bar) — the same develop-green family as the detail page's \"Enough keys\" chip.\n$inv-text-green: darken($develop-color, 12%);\n\n.invl {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// Header\n.invl-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 28px;\n  gap: 16px;\n\n  @media (max-width: 640px) { flex-direction: column; align-items: flex-start; margin-bottom: 20px; }\n\n  &__left { flex: 1; }\n  &__title-row { display: flex; align-items: center; gap: 12px; }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: $color-neutral-dark;\n    margin: 0;\n    letter-spacing: -0.02em;\n    font-family: $font-stack;\n    line-height: 1.2;\n\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n\n}\n\n// Breadcrumb\n.invl-breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: $color-neutral-mid;\n\n  li {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; font-size: 11px; }\n\n    a {\n      color: $body-content-color;\n      text-decoration: none;\n      transition: color 0.15s ease;\n      &:hover { color: $clarify-color; }\n    }\n\n    &.invl-breadcrumb__current { color: $color-neutral-dark; font-weight: 600; }\n  }\n}\n\n// Toolbar\n.invl-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 24px;\n  padding: 14px 20px;\n  background: $color-neutral-light;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n\n  @media (max-width: 767px) { gap: 10px; padding: 12px 16px; }\n  @media (max-width: 640px) {\n    .invl-searchbar { flex-basis: 100%; max-width: none; }\n    .invl-archived { margin-left: 0; }\n  }\n}\n\n// Combined search + status filter — one bordered unit\n.invl-searchbar {\n  display: flex;\n  align-items: center;\n  flex: 1 1 420px;\n  max-width: 620px;\n  min-width: 0;\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &:focus-within { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); }\n\n  &__icon { padding: 0 8px 0 14px; color: $color-neutral-mid; font-size: 13px; }\n\n  &__input {\n    flex: 1;\n    min-width: 0;\n    border: none;\n    outline: none;\n    background: transparent;\n    padding: 10px 8px;\n    font-size: 13px;\n    font-family: $font-stack;\n    color: $body-content-color;\n\n    &::placeholder { color: $color-neutral-mid; }\n  }\n\n  &__clear {\n    flex: 0 0 auto;\n    background: $color-neutral-mid;\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 10px;\n    padding: 0;\n    margin-right: 6px;\n    transition: background 0.15s ease;\n    &:hover { background: $body-content-color; }\n  }\n\n  &__divider { width: 1px; align-self: stretch; background: $color-grey-1; margin: 7px 0; }\n\n  &__select {\n    position: relative;\n    display: flex;\n    align-items: center;\n    transition: background 0.15s ease;\n    &:hover { background: $color-neutral-light; }\n  }\n\n  &__field {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: none;\n    outline: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 10px 34px 10px 14px;\n    font-size: 13px;\n    font-weight: 600;\n    font-family: $font-stack;\n    color: $body-content-color;\n  }\n\n  &__caret {\n    position: absolute;\n    right: 13px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: $color-neutral-mid;\n    font-size: 14px;\n    pointer-events: none;\n  }\n}\n\n.invl-archived {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 0 auto;\n  font-size: 13px;\n  font-weight: 500;\n  color: $color-neutral-mid;\n  cursor: pointer;\n  white-space: nowrap;\n\n  input { cursor: pointer; margin: 0; }\n}\n\n// Primary button\n.invl-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: $font-stack;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-decoration: none;\n  line-height: 1.4;\n\n  &--primary {\n    background: $develop-color;\n    color: #fff;\n    border-color: $develop-color;\n    &:hover { background: $color-dark-green; border-color: $color-dark-green; }\n  }\n}\n\n// Content area\n.invl-content {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid $color-grey-1;\n  overflow: hidden;\n  min-height: 200px;\n\n  .table-responsive { overflow-x: auto; }\n\n  table {\n    width: 100%;\n    margin-bottom: 0;\n    border-collapse: collapse;\n\n    thead tr {\n      background: $color-neutral-light;\n\n      th {\n        padding: 9px 10px;\n        font-size: 10px;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: $color-neutral-dark;\n        border-bottom: 2px solid $color-grey-1;\n        border-top: none;\n        white-space: nowrap;\n        font-family: $font-stack;\n        cursor: default;\n\n        &.cursor-pointer {\n          cursor: pointer;\n          &:hover { color: $clarify-color; }\n          i { margin-left: 4px; font-size: 12px; }\n        }\n      }\n    }\n\n    tbody tr {\n      transition: background-color 0.12s ease;\n      border-bottom: 1px solid $color-grey-1;\n      cursor: pointer;\n\n      &:hover { background-color: rgba($clarify-color, 0.03); }\n      &:nth-of-type(even) {\n        background-color: rgba($color-neutral-light, 0.5);\n        &:hover { background-color: rgba($clarify-color, 0.03); }\n      }\n\n      td {\n        padding: 8px 10px;\n        font-size: 12px;\n        color: $body-content-color;\n        vertical-align: middle;\n        border-top: none;\n\n        // Plain text links only (e.g. the Name column) — the action buttons\n        // (.invl-actions__opr) keep their own soft-tinted styling.\n        a:not(.invl-actions__opr) {\n          color: $body-content-color;\n          text-decoration: none;\n          font-weight: 500;\n          transition: color 0.15s ease;\n          &:hover { color: $clarify-color; }\n        }\n        a.invl-namelink { font-weight: 700; }\n      }\n    }\n  }\n}\n\n// Action buttons — replicates the Rosters `team-actions__opr` soft-tinted style\n.invl-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n\n  &__opr {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    padding: 0;\n    border-radius: 6px;\n    font-size: 13px;\n    line-height: 1;\n    border: 1px solid transparent;\n    cursor: pointer;\n    text-decoration: none;\n    transition: all 0.2s ease;\n\n    // Neutral grey at rest; each action reveals its colour on hover.\n    background: transparent;\n    color: #9aa0a6;\n    border-color: $color-grey-1;\n\n    &--edit:hover { background: $clarify-color; color: #fff; border-color: $clarify-color; transform: scale(1.08); }\n    &--copy:hover { background: $develop-color; color: #fff; border-color: $develop-color; transform: scale(1.08); }\n    &--delete:hover,\n    &--archive:hover { background: $implement-color; color: #fff; border-color: $implement-color; transform: scale(1.08); box-shadow: 0 2px 8px rgba($implement-color, 0.3); }\n    &--restore:hover { background: $develop-color; color: #fff; border-color: $develop-color; transform: scale(1.08); }\n  }\n}\n\n// States\n.invl-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n\n  & > i { font-size: 36px; margin-bottom: 16px; color: $color-neutral-mid; }\n  p { font-size: 15px; color: $color-neutral-mid; margin: 0; }\n}\n\n// ─────────────────────────────────────────────\n// Shared cell visuals (kept identical to the detail page)\n// ─────────────────────────────────────────────\n.inv-pill { display: inline-block; border-radius: 10px; padding: 3px 10px; font-size: 11px; font-weight: 600; }\n.inv-pill--open { background: rgba($develop-color, 0.12); color: $inv-text-green; }\n.inv-pill--closed { background: #f1f1f2; color: #8a9099; }\n// `overflow: hidden` backs up the clamp in progress() — the track must contain the\n// bar even if a width over 100% ever reaches it again.\n.inv-prog { height: 6px; background: #eef0f1; border-radius: 3px; margin-top: 3px; width: 72px; max-width: 100%; overflow: hidden; }\n.inv-prog__bar { height: 6px; background: $inv-text-green; border-radius: 3px; }\n// Scored count leads in large green (matches the Status/Presentation text green);\n// the \"/ total\" stays small and grey.\n.inv-prog__label {\n  display: inline-flex; align-items: baseline; gap: 3px; margin-bottom: 2px;\n  b { font-size: 17px; font-weight: 700; color: $inv-text-green; line-height: 1; }\n  i { font-style: normal; font-size: 11px; font-weight: 600; color: #9aa0a6; }\n}\n// Results cell is a link to the invitation detail (same grey-to-blue hover as the name).\n.invl-results {\n  display: inline-flex;\n  flex-direction: column;\n  text-decoration: none;\n  .inv-prog, .inv-prog__bar { display: block; }\n  &:hover .inv-prog__label b { color: $clarify-color; }\n}\n\n// Name & Organization links — same treatment as the Organizations listing:\n// grey at rest, Clarify blue on hover. The invitation name is bold for scanability.\n.invl-orglink,\n.invl-namelink {\n  color: $body-content-color !important;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.15s ease;\n  &:hover { color: $clarify-color !important; }\n}\n\n// Pagination\n.invl-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-top: 1px solid $color-grey-1;\n  flex-wrap: wrap;\n\n  &__info { font-size: 12px; color: $color-neutral-mid; }\n  &__ctrls { display: flex; gap: 4px; }\n  &__btn {\n    min-width: 30px;\n    height: 30px;\n    padding: 0 8px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    background: #fff;\n    color: $body-content-color;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.15s ease;\n\n    &:hover:not(:disabled):not(.is-active) { background: $color-neutral-light; border-color: $color-neutral-mid; }\n    &.is-active { background: $color-neutral-dark; color: #fff; border-color: $color-neutral-dark; }\n    &:disabled { opacity: 0.4; cursor: not-allowed; }\n  }\n}\n.invl-pager__left { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }\n.invl-perpage {\n  display: inline-flex; align-items: center; gap: 6px; margin: 0; font-size: 12px; color: $color-neutral-mid;\n  select { padding: 4px 8px; border: 1px solid $color-grey-1; border-radius: 6px; font-size: 12px; color: $body-content-color; cursor: pointer; outline: none; }\n}\n\n// Follow-up email status — pill (icon + date) when on, compact circle when off\n.invl-fu {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n\n  padding: 2px 9px;\n  border-radius: 10px;\n\n  // Presentation chip follows the invitation status: green while open, grey otherwise.\n  &--open { background: rgba($develop-color, 0.12); color: $inv-text-green; }\n  &--muted { background: #f1f1f2; color: #8a9099; }\n  &__date { white-space: nowrap; }\n}\n\n// Stacked deadline / presentation dates (one column)\n.invl-dates {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  line-height: 1.3;\n  white-space: nowrap;\n  &__lbl { color: #9aa0a6; font-size: 9px; text-transform: uppercase; letter-spacing: 0.03em; margin-right: 5px; }\n}\n.inv-avatar { display: inline-flex; width: 24px; height: 24px; border-radius: 50%; background: #00add0; color: #fff; align-items: center; justify-content: center; font-size: 9px; margin-right: 2px; }\n// Listing avatars are neutral: first organizer light grey, second a lighter grey.\n// Compound selectors so they win over the detail page's global .inv-avatar base rule.\n.inv-avatar.inv-avatar--grey { background: $color-grey-1; color: $color-neutral-dark; }\n.inv-avatar.inv-avatar--grey-lighter { background: $color-neutral-light; color: $color-neutral-dark; }\n.inv-avatar__more { color: #9aa0a6; font-size: 11px; }\n\n// ─────────────────────────────────────────────\n// New Invitation modal — replicates the Rosters `nt-modal` popup chrome\n// ─────────────────────────────────────────────\n.invm {\n  position: fixed;\n  inset: 0;\n  z-index: 100000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 50px 20px;\n\n  @media #{$mobile-up} { padding-left: 240px; }\n\n  &__overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); z-index: 0; }\n\n  &__card {\n    position: relative;\n    z-index: 1;\n    width: min(780px, 100%);\n    max-height: calc(100vh - 100px);\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 20px;\n    background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%));\n    border-bottom: 1px solid $color-grey-1;\n    flex-shrink: 0;\n  }\n\n  &__header-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    background: $develop-color;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    flex-shrink: 0;\n  }\n\n  &__title { font-size: 15px; font-weight: 700; color: $color-neutral-dark; font-family: $font-stack; margin: 0; line-height: 1.3; }\n  &__subtitle { font-size: 12px; color: $body-content-color; margin: 2px 0 0; line-height: 1.3; opacity: 0.7; }\n\n  &__close {\n    margin-left: auto;\n    width: 30px;\n    height: 30px;\n    border: 1px solid $color-grey-1;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    color: $color-neutral-mid;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n    &:hover { background: rgba($implement-color, 0.06); color: $implement-color; border-color: rgba($implement-color, 0.2); }\n  }\n\n  &__body { padding: 20px 24px 24px; overflow-y: auto; }\n\n  // the hosted wizard fills the modal — drop its page padding / max-width cap\n  .inv-wizard { max-width: none; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
